<template>
	<div class="stage-status-wrapper" :type="type">
		<div class="stage-status-icon">
			<Icon :name="iconName" size="small" :type="iconType" />
		</div>
		<div class="stage-status">
			{{ status }}
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "StageStatus",
	components: {
		Icon
	},
	props: {
		/**
		 * 'success' | 'error' | 'inProgress' | 'warning' | 'standby' | 'paused'
		 */
		type: {
			type: String,
			default: "inProgress",
			validator(value) {
				return [
					"success",
					"error",
					"inProgress",
					"warning",
					"disabled",
					"standby",
					"paused"
				].includes(value);
			}
		},
		/**
		 * Status of Stage
		 */

		status: {
			type: String,
			required: true
		}
	},
	computed: {
		iconName() {
			let iconName = "tick";
			switch (this.type) {
				case "error":
					iconName = "i-alert";
					break;
				case "inProgress":
					iconName = "loading";
					break;
				case "warning":
					iconName = "i-alert";
					break;
				case "standby":
					iconName = "i-history";
					break;
				case "paused":
					iconName = "i-pause";
					break;
			}
			return iconName;
		},
		iconType() {
			let iconType = "outlined";
			switch (this.type) {
				case "error":
					iconType = "filled";
					break;
				case "inProgress":
					iconType = "outlined";
					break;
				case "warning":
					iconType = "filled";
					break;
				case "standby":
					iconType = "filled";
					break;
				case "paused":
					iconType = "filled";
					break;
			}
			return iconType;
		}
	}
});
</script>
<style lang="scss">
$font-color: var(--dashboard-font-light);
$disabled-color: var(--dashboard-font-light);

$status-colors: (
	"success": $font-color,
	"error": var(--dashboard-danger),
	"inProgress": $font-color,
	"warning": var(--dashboard-warning),
	"standby": $disabled-color,
	"paused": $disabled-color,
	"disabled": $disabled-color
);

.stage-status-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
	// gap: 8px;
	> * {
		margin-right: 8px;
	}
	> .stage-status {
		color: $font-color;
		font-size: 14px;
		line-height: 14px;
		word-break: break-all;
	}

	> .stage-status-icon {
		display: flex;
		align-items: center;
		> .icon-container {
			height: 14px;
			width: 14px;
			> .icon {
				height: 14px;
				width: 14px;
				> svg {
					transform: scale(1.2);
				}
			}
		}
	}

	@each $type, $color in $status-colors {
		&[type="#{$type}"] {
			> .stage-status {
				color: $color;
			}

			> .stage-status-icon > .icon-container > .icon[type="filled"] > svg {
				fill: $color !important;
			}
			> .stage-status-icon > .icon-container > .icon[type="outlined"] > svg {
				stroke: $color !important;
			}
		}
	}

	&[type="inProgress"] {
		> .stage-status-icon > .icon-container > .icon[type="filled"] {
			animation: spin 2s linear infinite !important;
		}
	}
}

@keyframes spin {
	100% {
		transform: rotate(360deg);
	}
}
</style>
